


























































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DxDataGrid, {
  DxColumn,
  DxRemoteOperations,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxSelection,
  DxEditing  
} from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { ClientAgentService } from '../../service/ClientAgentService';
import { QuestelServicesClient } from '@questelservices/common/dist';
import { DxButton, DxTooltip, DxCheckBox, DxLoadPanel } from 'devextreme-vue';
import _ from 'lodash';
 import { Popup } from '@questelservices/common-vue';
import { ActivityPlannerService } from '@/service/ActivityPlannerService';
import { PageTitle, DataGrid } from '@questelservices/common-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import dialog from 'devextreme/ui/dialog';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { BatchService } from '../../service/BatchService';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { ClientSummaryDto } from '@/models/ClientSummaryDto';
import { ReportTypeEnum } from '@/models/ReportTypeEnum';
import { SendBatchReportsRequestDto } from '@/models/batch/SendBatchReportsRequestDto';
import SendReportsConfirmation from '@/components/auditor/send-reports-confirmation.vue';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxRemoteOperations,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxToolbarItem,
    DxSelection,
    DxTooltip,
    DxEditing,
    DxLoadPanel,
    DxButton,
    SendReportsConfirmation
  }
})
export default class AllClientsSummary extends Vue {
    private showDialog: boolean = false;
    private allClientsSummaryStore: CustomStore;
    private readonly analysisReportType: ReportTypeEnum = ReportTypeEnum.Analysis;
    private readonly auditorReportType: ReportTypeEnum = ReportTypeEnum.Auditor;
    private readonly sendReportsConfirmationRef: string = 'sendReportsConfirmationRef';
    readonly dataGridRef: string = 'dataGridRef';

    private get dataGrid() {
      return (this.$refs[this.dataGridRef] as DxDataGrid).instance;
    }

    private get sendReportsConfirmation() {
      return this.$refs[this.sendReportsConfirmationRef] as SendReportsConfirmation;
    }

    constructor() {
        super();
        this.activityPlannerService = new ActivityPlannerService('/api');
        this.batchService = new BatchService();
        this.allClientsSummaryStore = new CustomStore({
            key: 'ClientId',
            loadMode: 'raw',         
            load: options => {
              return this.activityPlannerService
                  .clientSummary(options)
                  .then(result => {
                      let data = result.data as ClientSummaryDto[];
                      this.processPreSelectedBatchIds(data);
                      return data;
                  })
                  .catch(err => {
                      return [];
                  })
            },               
            update: (key, values) => {                
                if (key) {                           
                    return this.batchService.setReadyForReporting(key)
                        .then(success => {                            
                            return success;
                        })
                        .catch(err => {
                            notify('Failed to save ready for reporting', 'error', 3000);
                        });
                } else {
                    return Promise.resolve();
                }                           
            }  
        });
    }
 
    displayMessage: string = '';
    hoveredItem : string = "";
    tooltipVisible: boolean = false;
    sendingReport: boolean = false;
    listOfSelectedBatchIds: Array<Guid> = [];
    tempSelectedBatchIds: Array<Guid> = [];
    batchService: BatchService;
    activityPlannerService: ActivityPlannerService;

    processPreSelectedBatchIds(data: ClientSummaryDto[]) {
        this.listOfSelectedBatchIds = data.filter(item => item.ReadyForReporting).map(item => item.ClientId);
        this.tempSelectedBatchIds = _.cloneDeep(this.listOfSelectedBatchIds);
    }

    OnDataErrorOccured(e: any) {
        if (e != null && e.error != null) {
            e.error.message = "Failed to load data.";
        }
    }

    onContentReady(e: any) {
        if (!e.component.__firstLoad) {
            e.component.option("selectedRowKeys", this.listOfSelectedBatchIds);
        }
    }    

    onRowValidating(e: any) {
        if (e.newData) {
            let data = e.component.getDataSource().items();
            let keyData = data.find((x:any) => x.ClientId == e.key);
            
            if (keyData.MatterNeedsAuditingCount > 0 && e.newData.ReadyForReporting) {
                    e.promise =  dialog.confirm(`<b>${keyData.ClientName}</b>, <b>${keyData.LatestBatchName}</b> still has <b>${keyData.MatterNeedsAuditingCount}</b>
                    ${keyData.MatterNeedsAuditingCount > 1 ? "cases": "case"} that have not yet been audited. <br />Are you sure you want to set this to be ready to send?`
                    , "Confirm Ready to Send")
                    .then(res => {
                       if (!res) {
                           e.component.cancelEditData();
                           return;
                       }
                    });
            }
            else {
                e.component.saveEditData();
            }

            this.refreshDataGrid();
        }
    }

    onRowPrepared(e: any) {
        if (e.rowType == "data" && e.data) {
            if (e.data.MatterNeedsAuditingCount > 0) {
                e.rowElement.style['background-color'] = "#f9e08c";
            }
        }
    }
    
    onCellPrepared(e: any) {
        if (e.rowType === 'data' && e.data) {
            e.cellElement.setAttribute("id", `audit-${e.columnIndex}-${e.data.ClientName}`);
        }
    }

    refreshDataGrid() {
      if (this.dataGrid) {
        this.dataGrid.refresh();
      }
    }

    sendBatchReport(data: any, reportType: ReportTypeEnum) {
      if (data != null && data.data != null) {
        this.sendReportsConfirmation.reportType = reportType;
        this.sendReportsConfirmation.client = {
          ClientId: data.data.ClientId,
          ClientName: data.data.ClientName
        };

        this.sendReportsConfirmation.show();
      }
    }

    private async onSendReportsConfirmationHiding() {
      if (this.sendReportsConfirmation.dialogResult === true && this.sendReportsConfirmation.selectedBatch != null) {
        let batchName = this.sendReportsConfirmation.selectedBatch.BatchName;
        let reportTypeName = this.sendReportsConfirmation.reportTypeName;
        let clientName = this.sendReportsConfirmation.selectedBatch.ClientName;

        notify(`Sending batch ${batchName} ${reportTypeName} reports for ${clientName}...`, "info");
        this.sendingReport = true;

        let options: SendBatchReportsRequestDto = {
          ReportType: this.sendReportsConfirmation.reportType,
          ForceSend: true
        };

        this.batchService.sendReport(this.sendReportsConfirmation.selectedBatch.BatchId, options)
          .then(response => {
            notify(`Batch ${batchName} ${reportTypeName} reports successfully sent for ${clientName}`, "success");
          })
          .catch(reason => {
            let message = `Failed to send batch ${batchName} ${reportTypeName} reports for ${clientName}.`;
            if (reason != null && reason.Message != null) {
              message += ` ${reason.Message}`;
            }

            dialog.alert(message, "Report Sending Failed");
          })
          .finally(() => {
            this.sendingReport = false;
          });
      }
    }
  }
